export default __webpack_public_path__ + "static/media/planet-odyssey-poster.1449e2d3.jpg";